import { gql } from '@apollo/client';

export const REFRESH_HOTEL_CHAT_AUTH_TOKEN_MUTATION = gql`
  mutation RefreshHotelChatAuthToken {
    refreshHotelChatAuthToken
  }
`;
